// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-7893adcf]{font-family:Arial,sans-serif;padding:10px;text-align:center}.text[data-v-7893adcf]{font-size:22px;margin-bottom:0}.full-height[data-v-7893adcf]{height:100%}.chart-header[data-v-7893adcf]{height:auto}.min-400[data-v-7893adcf]{min-height:400px}.chart-body[data-v-7893adcf]{align-items:center;display:flex;height:100%;justify-content:center}.italic[data-v-7893adcf]{font-style:italic}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
